<template>
    <activation-file :file="asset" :show-date="false" />
</template>

<script>
    import ActivationFile from './ActivationFile.vue';

    export default {
        /**
         * Component name
         *
         * @type {String}
         */
        name: 'ActivationsBrandAsset',

        /**
         * Components
         *
         * @type {Object}
         */
        components: {
            ActivationFile
        },

        /**
         * Component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * Asset object
             */
            asset: {
                type: Object,
                required: true
            }
        }
    };
</script>
